<template>
  <f7-link style="padding: 0px;" @click="$emit('click')">
    <div style="padding-right: 15px;">
      <div id="title">{{title}}<slot name="title" /></div>
      <div id="subtitle">{{subtitle}}<slot name="subtitle" /></div>
    </div>
    <slot name="after" />
  </f7-link>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String
    },
    icon: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
#title {
  height: 18px;
  line-height: 18px;
  font-size: 18px;
  margin: 3px 0px 5px;
}

#subtitle {
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
}
</style>
